import orderkeyIcon from 'assets/images/logos/orderkey-hub-short.png';
import CjLogoIcon from 'assets/images/logos/cj_star_logo.png';
import { useSelector } from 'react-redux';

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  
  const flavour = useSelector((state) => state.auth.flavour)
  const isExternal = flavour && flavour.isExternal;
  
  return <img src={isExternal ? CjLogoIcon : orderkeyIcon} alt='Logo' width={200} height={'100%'} />;

};

export default LogoIcon;
